import { render, staticRenderFns } from "./ReportsGameDetails.vue?vue&type=template&id=d3f3e252&scoped=true"
import script from "./ReportsGameDetails.vue?vue&type=script&lang=js"
export * from "./ReportsGameDetails.vue?vue&type=script&lang=js"
import style0 from "./ReportsGameDetails.vue?vue&type=style&index=0&id=d3f3e252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f3e252",
  null
  
)

export default component.exports